import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.3/js/sparta-events-utility";
import _ from "utilities/vendor/lodash/4.13.1/js/lodash.custom.min";
import spartaMediaQueryUtility from "utilities/global/sparta-mediaquery-utility/2.0.4/js/sparta-mediaquery-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.0.4/js/sparta-store-utility";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
/* global $ _ spartaMediaQueryUtility */

/**
 * Utility to share content in multiple places on the page.
 */
class ShareContent {
  /**
   * Change content plugin can move/copy content around in the DOM based on provided rules in the
   * markup or init. Right now it is handling breakpoint changes, moving content from one location
   * to another.
   * @param {object} data - Breakpoint change event information.
   * @param {string} viewport - The current viewport.
   * @returns {void}
   */
  breakpoint(data, viewport) {
    const currentViewport = viewport || spartaMediaQueryUtility.matchedQuery.viewport;
    const $nodes = $(`[data-rwd-content=${data.content}]`);

    if (data.action === 'move') {
      const $content = $nodes.filter('[data-rwd-content-current="true"]').children();
      $nodes
        .empty().removeAttr('data-rwd-content-current')
        .each(function eachNode() {
          const $node = $(this);
          const criterion = $node.attr('data-rwd-content-rule');
          if ($.inArray(currentViewport, data.viewports[criterion]) > -1) {
            if (data.content === 'search' && currentViewport !== 'small') {
              const searchInterval = setInterval(() => {
                if ($node.length) {
                  if ($content.length) {
                    $node
                      .append($content.first())
                      .attr('data-rwd-content-current', 'true');
                  }
                  clearInterval(searchInterval);

                  // Execute the callback after the search content is in place.
                  if (typeof data.callback === 'function') {
                    data.callback();
                  }
                }
              }, 50);

              // Clear this interval if it's still running after 5 seconds.
              setTimeout(() => {
                clearInterval(searchInterval);
              }, 5000);
            } else {
              $node
                .append($content.first())
                .attr('data-rwd-content-current', 'true');
            }
          }
        });

      // Fix for small breakpoint search menu (when resizing).
      // Due to a timing issue, the small breakpoint hasn't been initialized yet, so we need a
      // small delay, accompanied by the `$content` append from above.
      if (data.content === 'search' && currentViewport === 'small') {
        // Find the small breakpoint search, and ensure it gets initialized.
        const navMenuInterval = setInterval(() => {
          const $smallSearch = $('.header-search[data-rwd-content-rule="small"]');
          if ($smallSearch.length) {
            const $hiddenSearch = $smallSearch.find('.search-input-container.hide');
            if ($content.length && ($smallSearch.is(':empty') || $hiddenSearch.length)) {
              $hiddenSearch.removeClass('hide');
              $smallSearch
                .empty()
                .append($content.first())
                .attr('data-rwd-content-current', 'true');
            }
            clearInterval(navMenuInterval);

            // Execute the callback after the search content is in place.
            if (typeof data.callback === 'function') {
              data.callback();
            }
          }
        }, 50);

        // Clear this interval if it's still running after 5 seconds.
        setTimeout(() => {
          clearInterval(navMenuInterval);
        }, 5000);
      }
    } else if (typeof data.callback === 'function') {
      data.callback();
    }
  }

  /**
   * Sets up the initial utility configuration.
   * @param {object} options - Custom configuration options.
   * @returns {void}
   */
  init(options) {
    const data = {};
    const defaults = {
      content: '',
      criterion: '',
      action: '',
      viewports: {
        small: ['small'],
        medium: ['medium'],
        large: ['large', 'largeCentered', 'xlarge', 'xxlarge'],
        'not-small': ['medium', 'large', 'largeCentered', 'xlarge', 'xxlarge'],
        'not-large': ['small', 'medium'],
        all: ['small', 'medium', 'large', 'largeCentered', 'xlarge', 'xxlarge'],
      },
    };
    Object.assign(data, defaults, options);

    if (data.criterion === 'breakpoint') {
      spartaEventsUtility.sub(
        spartaMediaQueryUtility.EVENTS.BREAKPOINT_CHANGE,
        _.debounce(resp => this.breakpoint(data, resp.data.viewport), 100),
      );
      setTimeout(() => this.breakpoint(data), 0);
    }
  }
}

export default new ShareContent();
